import { createTheme } from '@mui/material/styles';

const colors = {
  lime: '#CEFF00',
  black: '#000000',
  white: '#FFFFFF',
  lightGrey: '#F5F5F5',
  silver: '#C8C8C8',
  black85: '#262626',
  black60: '#4A4A4A',
  scoreGreen: '#22c55e',
  scoreYellow: '#f59e0b',
  scoreRed: '#ef4444',
};

export { colors };

const theme = createTheme({
  palette: {
    primary: {
      main: colors.lime,
      contrastText: colors.black,
    },
    secondary: {
      main: colors.black,
      contrastText: colors.white,
    },
    background: {
      default: colors.white,
      paper: colors.lightGrey,
    },
    text: {
      primary: colors.black85,
      secondary: colors.black60,
    },
    success: { main: colors.scoreGreen },
    warning: { main: colors.scoreYellow },
    error: { main: colors.scoreRed },
    divider: colors.silver,
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    h1: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    h2: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    h3: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    h4: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    h5: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    h6: { fontFamily: "'Poppins', sans-serif", fontWeight: 600 },
    body1: { fontFamily: "'Poppins', sans-serif", fontWeight: 300 },
    body2: { fontFamily: "'Poppins', sans-serif", fontWeight: 300, fontSize: '0.875rem' },
    button: { fontFamily: "'Poppins', sans-serif", fontWeight: 600, textTransform: 'none' },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          padding: '10px 24px',
          fontSize: '0.9375rem',
        },
        containedPrimary: {
          backgroundColor: colors.lime,
          color: colors.black,
          '&:hover': {
            backgroundColor: '#b8e600',
          },
        },
        outlinedPrimary: {
          borderColor: colors.black85,
          color: colors.black85,
          '&:hover': {
            borderColor: colors.black,
            backgroundColor: 'rgba(0,0,0,0.04)',
          },
        },
        textPrimary: {
          color: colors.black85,
          '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          '&.Mui-checked': {
            color: colors.black,
            '& + .MuiSwitch-track': {
              backgroundColor: colors.lime,
              opacity: 1,
            },
          },
        },
        track: {
          backgroundColor: colors.silver,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: colors.silver,
          '&.Mui-checked': {
            color: colors.black,
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: colors.black60,
          '&.Mui-selected': {
            color: colors.black,
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: colors.black,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        colorPrimary: {
          color: colors.black85,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: colors.black,
          color: colors.white,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          '& .MuiTablePagination-selectIcon': { color: colors.black60 },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.black85,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: colors.black85,
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:after': {
            borderBottomColor: colors.black85,
          },
        },
      },
    },
  },
});

export default theme;
